/* tslint:disable */
/* eslint-disable */
/**
 * OneAir.AdminPortal
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    TimeOfDayResponse,
    TimeOfDayResponseFromJSON,
    TimeOfDayResponseFromJSONTyped,
    TimeOfDayResponseToJSON,
} from './';

/**
 * 
 * @export
 * @interface CriteriaForBookingDateTimeResponse
 */
export interface CriteriaForBookingDateTimeResponse {
    /**
     * 
     * @type {boolean}
     * @memberof CriteriaForBookingDateTimeResponse
     */
    exclude?: boolean;
    /**
     * 
     * @type {Date}
     * @memberof CriteriaForBookingDateTimeResponse
     */
    from?: Date;
    /**
     * 
     * @type {Date}
     * @memberof CriteriaForBookingDateTimeResponse
     */
    to?: Date;
    /**
     * 
     * @type {string}
     * @memberof CriteriaForBookingDateTimeResponse
     */
    ianaTimeZone?: string | null;
    /**
     * 
     * @type {Array<number>}
     * @memberof CriteriaForBookingDateTimeResponse
     */
    daysOfWeek?: Array<number> | null;
    /**
     * 
     * @type {Array<TimeOfDayResponse>}
     * @memberof CriteriaForBookingDateTimeResponse
     */
    timesOfDay?: Array<TimeOfDayResponse> | null;
}

export function CriteriaForBookingDateTimeResponseFromJSON(json: any): CriteriaForBookingDateTimeResponse {
    return CriteriaForBookingDateTimeResponseFromJSONTyped(json, false);
}

export function CriteriaForBookingDateTimeResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): CriteriaForBookingDateTimeResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'exclude': !exists(json, 'exclude') ? undefined : json['exclude'],
        'from': !exists(json, 'from') ? undefined : (new Date(json['from'])),
        'to': !exists(json, 'to') ? undefined : (new Date(json['to'])),
        'ianaTimeZone': !exists(json, 'ianaTimeZone') ? undefined : json['ianaTimeZone'],
        'daysOfWeek': !exists(json, 'daysOfWeek') ? undefined : json['daysOfWeek'],
        'timesOfDay': !exists(json, 'timesOfDay') ? undefined : (json['timesOfDay'] === null ? null : (json['timesOfDay'] as Array<any>).map(TimeOfDayResponseFromJSON)),
    };
}

export function CriteriaForBookingDateTimeResponseToJSON(value?: CriteriaForBookingDateTimeResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'exclude': value.exclude,
        'from': value.from === undefined ? undefined : (value.from.toISOString()),
        'to': value.to === undefined ? undefined : (value.to.toISOString()),
        'ianaTimeZone': value.ianaTimeZone,
        'daysOfWeek': value.daysOfWeek,
        'timesOfDay': value.timesOfDay === undefined ? undefined : (value.timesOfDay === null ? null : (value.timesOfDay as Array<any>).map(TimeOfDayResponseToJSON)),
    };
}


